import { useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { CircularProgress, Grid, TextField } from '@material-ui/core';
import AddressApi from 'services/api/address';
import CitiesApi from 'services/api/city';

function AddressFields(props) {
  const {
    disabled,
    errors,
    handleAddressNameChange,
    handleChange,
    handleCityChange,
    showAddressTitle,
    touched,
    values
  } = props;

  const [inseeCode, setInseeCode] = useState(null);
  const [suggestedAddresses, setSuggestedAddresses] = useState([]);
  const [suggestedCities, setSuggestedCities] = useState([]);
  const [open, setOpen] = useState(false);
  const loading = open && suggestedAddresses.length === 0;

  useEffect(() => {
    let active = true;

    if (!values.address_name) {
      setSuggestedAddresses([]);
      return;
    }

    let strAddress = '';
    if (values.street_number) strAddress += `${values.street_number}`;
    strAddress += ` ${values.address_name}`;

    (async () => {
      const { features } = await AddressApi.searchAddress(strAddress, inseeCode, values.zip_code);
      let addressName = [];

      const filteredAddress = features.filter(addr => {
        let addrName = addr.properties.type === 'street'? addr.properties.name : addr.properties.street;

        if(!addressName.find(filteredName => filteredName === addrName)
        ){
          addressName.push(addrName);
          return true;
        }
        return false;
      })
      if (active) setSuggestedAddresses(filteredAddress);
    })();

    return () => {
      active = false;
    }
  }, [inseeCode, values.address_name, values.street_number, values.zip_code])

  useEffect(() => {
    const zipCode = values.zip_code;
    if (zipCode && zipCode.length === 5) {
      CitiesApi.getCitiesByZipcode(zipCode)
        .then(({ cities }) => { setSuggestedCities(cities); })
        .catch(() => {});
    } else if (!zipCode) setSuggestedCities([]);
  }, [values.zip_code]);

  const onAddressSelected = (event) => {
    handleAddressNameChange(event, event.target.textContent);
  }

  const onCitySelected = (event, value) => {
    handleCityChange(event, value);
    setInseeCode(suggestedCities[event.target.value].insee_code);
  }

  return (
    <Grid container spacing={3}>
      {!!showAddressTitle &&
        <Grid item sm={12} md={4}>
          <TextField
            disabled={disabled}
            fullWidth
            label='Titre de l’adresse'
            name='title'
            variant='outlined'
            value={values.title}
            onChange={handleChange}
            error={touched.title && Boolean(errors.title)}
            helperText={touched.title && errors.title}
          />
        </Grid>
      }

      <Grid container item spacing={3}>
        <Grid container item spacing={3}>
          <Grid item xs={2}>
            <TextField
                disabled={disabled}
                label='N°'
                name='street_number'
                variant='outlined'
                value={values.street_number}
                onChange={handleChange}
                error={touched.street_number && Boolean(errors.street_number)}
                helperText={touched.street_number && errors.street_number}
            />
          </Grid>

          <Grid item xs={2}>
            <TextField
                disabled={disabled}
                label='Indice'
                name='street_index'
                variant='outlined'
                value={values.street_index}
                onChange={handleChange}
                error={touched.street_index && Boolean(errors.street_index)}
                helperText={touched.street_index && errors.street_index}
            />
          </Grid>

          <Grid item xs={8}>
            <Autocomplete
                disabled={disabled}
                disableClearable
                freeSolo
                loading={loading}
                loadingText='Chargement ...'
                open={open}
                onOpen={() => { setOpen(true) }}
                onClose={() => { setOpen(false) }}
                inputValue={values.address_name}
                onInputChange={(event, value) => {
                  handleAddressNameChange(event, value);
                  if (value.length === 0) setSuggestedAddresses([]);
                }}
                value={values.address_name}
                onChange={onAddressSelected}
                options={suggestedAddresses}
                getOptionLabel={() => values.address_name}
                renderOption={(option) => option.properties.street ?? option.properties.name}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label='Nom de la voie'
                        variant='outlined'
                        error={touched.address_name && Boolean(errors.address_name)}
                        helperText={touched.address_name && errors.address_name}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                              <>
                                {loading ? (
                                    <CircularProgress color='inherit' size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                          ),
                        }}
                    />
                }
            />
          </Grid>
        </Grid>

        <Grid item xs={4}>
          <TextField
            disabled={disabled}
            fullWidth
            label='Code postal'
            name='zip_code'
            variant='outlined'
            value={values.zip_code}
            onChange={handleChange}
            error={touched.zip_code && Boolean(errors.zip_code)}
            helperText={touched.zip_code && errors.zip_code}
          />
        </Grid>

        <Grid item xs={8}>
          <Autocomplete
            disabled={disabled}
            disableClearable
            freeSolo
            inputValue={values.city_name}
            onInputChange={handleCityChange}
            value={values.city_name}
            onChange={onCitySelected}
            options={suggestedCities.map(city => city.name)}
            renderInput={(params) =>
              <TextField
                {...params}
                label='Ville'
                variant='outlined'
                error={touched.city_name && Boolean(errors.city_name)}
                helperText={touched.city_name && errors.city_name}
              />
            }
          />
        </Grid>

      </Grid>
    </Grid>
  )
}

export default AddressFields;
